import { BaseModel, BaseModelClass } from './baseModel';
import { ProfileStatus } from './profile';
import { Badge, Certification } from './index';

export interface TeamCertificationSummary extends BaseModel {
  certificationId: string;
  name: string;
  progress: number;
}

export interface TeamAgent {
  id: string;
  displayName: string;
  roles: string[];
  agentPerformance?: {
    callCount: number;
    avgScore: number | null;
    trend: number | null;
  };
}

export interface TeamMember {
  id: string;
  displayName: string;
  lastSeen: string | null;
  status: ProfileStatus;
  hoursInCourses: number;
  totalCoursesCompleted: number;
  progress: number;
  badges?: Badge[];
  certifications?: Certification[];
  agentPerformance?: {
    callCount: number;
    avgScore: number | null;
    trend: number | null;
  };
}

export class TeamSummary extends BaseModelClass {
  seats: {
    usedSeats: number;
    totalSeats: number;
  };
  metrics: {
    activeUsers: number;
    totalUsers: number;
    totalCoursesCompleted: number;
  };
  report: {
    certifications: TeamCertificationSummary[];
  };
  users?: TeamMember[];
  agents?: TeamAgent[];
  shop?: boolean;

  constructor() {
    super();
    this.seats = {
      usedSeats: 0,
      totalSeats: 0
    };
    this.metrics = {
      activeUsers: 0,
      totalUsers: 0,
      totalCoursesCompleted: 0
    };
    this.report = {
      certifications: []
    };
    this.users = [];
    this.agents = [];
    this.shop = false;
  }
}
